import { 
    GET_STORE_PICKER_DATA_REQUEST, 
    GET_STORE_PICKER_DATA_SUCCESS, 
    GET_STORE_PICKER_DATA_ERROR,
    UPDATE_STORE_PICKER_VALUE,
    RESET_STORE_PICKER_ITEMS
} from '../action-types'

const initialState = {
    storeId: null,
    status: 'idle',
    items: []
}
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case GET_STORE_PICKER_DATA_REQUEST:
            return {...state, status: 'loading' }
        case GET_STORE_PICKER_DATA_SUCCESS:
            return {
                ...state,
                status: 'fulfilled',
                items: payload.results
            }
        case GET_STORE_PICKER_DATA_ERROR:
            return { ...state, status: 'error' }
        case UPDATE_STORE_PICKER_VALUE:
            return { ...state, storeId: payload }
        case RESET_STORE_PICKER_ITEMS:
            return {...state, status: 'idle', items: [] }
        default:
            return state
    }
}